import React from "react";

const Loading = () => {
  return (
    <div className="section-center">
      <div className="loading"></div>
    </div>
  );
};

export default Loading;
